import styled from 'styled-components';

const Input = styled.input`
    &:hover {
    border: 1px solid ${props => props.borderColor};
    }
`;

export default Input;



// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/Input.jsx